(ns io.daskul.tutorial.webapp.views.change-password
  "Change-password section (used in Settings) + a standalone page wrapper."
  (:require
   [uix.core :refer [defui $ use-state use-effect]]
   [uix.re-frame :as urf]
   [re-frame.core :as rf]
   [io.daskul.tutorial.webapp.domain.auth.change-password-events :as cp.events]
   [io.daskul.tutorial.webapp.domain.auth.change-password-subs :as cp.subs]
   [io.daskul.webapp.ui :as ui]
   [io.daskul.webapp.ui.icons :as icons]))

(defui password-section
  "Heading + change-password form. No outer card — the caller supplies it."
  []
  (let [[current-pw set-current-pw!] (use-state "")
        [new-pw set-new-pw!] (use-state "")
        [confirm-pw set-confirm-pw!] (use-state "")
        [confirm-error set-confirm-error!] (use-state nil)
        loading? (urf/use-subscribe [::cp.subs/loading?])
        error (urf/use-subscribe [::cp.subs/error])
        success? (urf/use-subscribe [::cp.subs/success?])]

    (use-effect
     (fn [] (fn [] (rf/dispatch [::cp.events/reset])))
     [])

    (use-effect
     (fn []
       (when success?
         (set-current-pw! "")
         (set-new-pw! "")
         (set-confirm-pw! "")
         (set-confirm-error! nil)))
     [success?])

    ($ ui/stack {:gap "md"}
      ($ ui/stack {:gap "xs"}
        ($ ui/group {:gap "xs"}
          ($ icons/icon-lock {:size 22 :stroke 1.5})
          ($ ui/title {:order 4} "Change Password"))
        ($ ui/text {:c "dimmed" :size "sm"}
          "Enter your current password and choose a new one."))

      (when success?
        ($ ui/success-alert "Your password has been changed successfully."))
      (when error
        ($ ui/error-alert error))

      ($ :form
        {:on-submit
         (fn [e]
           (.preventDefault e)
           (if (not= new-pw confirm-pw)
             (set-confirm-error! "Passwords do not match")
             (do
               (set-confirm-error! nil)
               (rf/dispatch [::cp.events/change-password
                             {:current-password current-pw
                              :new-password new-pw}]))))}
        ($ ui/stack {:gap "md"}
          ($ ui/password-input
            {:label "Current Password"
             :placeholder "Enter your current password"
             :value current-pw
             :on-change #(set-current-pw! (.. % -target -value))
             :required true
             :size "md"})
          ($ ui/password-input
            {:label "New Password"
             :placeholder "Min. 12 characters — try a passphrase"
             :value new-pw
             :on-change #(do (set-new-pw! (.. % -target -value))
                             (when confirm-error (set-confirm-error! nil)))
             :required true
             :size "md"
             :min-length 12
             :max-length 72})
          ($ ui/password-input
            {:label "Confirm New Password"
             :placeholder "Re-enter new password"
             :value confirm-pw
             :on-change #(do (set-confirm-pw! (.. % -target -value))
                             (when confirm-error (set-confirm-error! nil)))
             :required true
             :size "md"
             :error confirm-error})
          ($ ui/group {:justify "flex-end" :mt "xs"}
            ($ ui/button
              {:type "submit" :size "md" :loading loading?}
              "Change Password")))))))

(defui change-password-page
  "Standalone /change-password route — centered card wrapping the section."
  []
  ($ ui/container {:size "xs" :py "xl" :px "md"}
    ($ ui/paper {:shadow "sm" :p "xl" :radius "md" :style {:width "100%"}}
      ($ password-section))))
